import { useAbility } from '@cast/shared-ability-data-access';

export const useHideHpa = () => {
  return {
    // true for new customers
    // false for old customers
    hideHpa: useAbility().can('view', 'ClusterWorkloadHideHpa'),
  };
};
